import React from "react";

import ContentCore from "../../../core/workingContent";

const TaskReturnUI = () => {
  return (
    <ContentCore />
  )
}

export default TaskReturnUI